import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

const HRPayrollPage: React.FC = () => {
    return (
        <Fragment>
            <Helmet>
                <title>HR & Payroll Solutions | AquarLabs</title>
                <meta name="description" content="Streamline your HR operations with AquarLabs' comprehensive HR & Payroll ERP solutions. Automate payroll processing, employee management, and compliance tracking." />
                <meta name="keywords" content="HR software, payroll solutions, HRMS, human resources management, employee management, payroll automation, HR ERP, AquarLabs" />
            </Helmet>
            <div className="about-page inner-page">
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="HR & Payroll Solutions" pagesub="HR & Payroll" parentPage="Solutions" parentLink="/service" />

                        {/* Hero Section */}
                        <section className="service-hero-section" style={{ padding: "80px 0", background: "linear-gradient(135deg, rgba(252, 144, 56, 0.1) 0%, rgba(0, 2, 15, 0.8) 100%)" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-8">
                                        <h1 style={{ fontSize: "3rem", marginBottom: "20px", color: "#fff" }}>HR & Payroll Solutions</h1>
                                        <p style={{ fontSize: "1.25rem", color: "rgba(255,255,255,0.8)", lineHeight: "1.8" }}>
                                            Transform your human resources operations with intelligent automation. Our HR & Payroll solutions streamline employee management, automate payroll processing, and ensure compliance across your organization.
                                        </p>
                                        <Link to="/contact-us" className="thm-btn agency-btn" style={{ marginTop: "30px", display: "inline-block" }}>
                                            <span className="text">Get Started</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Overview Section */}
                        <section style={{ padding: "80px 0" }}>
                            <div className="container">
                                <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase", letterSpacing: "2px" }}>Overview</span>
                                <h2 style={{ fontSize: "2.5rem", margin: "15px 0 30px", color: "#fff" }}>Intelligent HR Management for Modern Enterprises</h2>
                                <p style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "rgba(255,255,255,0.8)" }}>
                                    AquarLabs' HR & Payroll solutions provide a unified platform for managing your entire employee lifecycle—from recruitment and onboarding to payroll, benefits, and offboarding. Our AI-powered systems reduce manual work, eliminate errors, and provide actionable insights into your workforce.
                                </p>
                                <p style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "rgba(255,255,255,0.8)", marginTop: "20px" }}>
                                    Whether you're a growing startup or an established enterprise, our scalable solutions adapt to your unique HR processes while ensuring compliance with local and international labor regulations.
                                </p>
                            </div>
                        </section>

                        {/* Services Section */}
                        <section style={{ padding: "80px 0", background: "rgba(0,2,15,0.3)" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase" }}>Our Capabilities</span>
                                        <h2 style={{ fontSize: "2rem", margin: "15px 0", color: "#fff" }}>Complete HR & Payroll Suite</h2>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="row">
                                            {[
                                                {
                                                    title: "Payroll Automation",
                                                    desc: "Accurate, timely payroll processing with zero errors.",
                                                    items: ["Multi-currency Support", "Tax Calculation & Filing", "Direct Deposit Integration"]
                                                },
                                                {
                                                    title: "Employee Management",
                                                    desc: "Centralized employee data and self-service portals.",
                                                    items: ["Digital Employee Records", "Leave & Attendance Tracking", "Performance Management"]
                                                },
                                                {
                                                    title: "Recruitment & Onboarding",
                                                    desc: "Streamline hiring from job posting to first day.",
                                                    items: ["ATS Integration", "Automated Onboarding Workflows", "Document Management"]
                                                },
                                                {
                                                    title: "Compliance & Reporting",
                                                    desc: "Stay compliant with automated regulatory tracking.",
                                                    items: ["Labor Law Compliance", "Audit-Ready Reports", "Custom Analytics Dashboards"]
                                                }
                                            ].map((activity, index) => (
                                                <div key={index} className="col-md-6" style={{ marginBottom: "30px" }}>
                                                    <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "12px", padding: "30px", height: "100%" }}>
                                                        <h3 style={{ fontSize: "1.25rem", color: "#fff", marginBottom: "15px" }}>
                                                            <span style={{ color: "#fc9038" }}>●</span> {activity.title}
                                                        </h3>
                                                        <p style={{ fontSize: "0.95rem", color: "rgba(255,255,255,0.7)", marginBottom: "15px" }}>{activity.desc}</p>
                                                        <ul style={{ listStyle: "none", padding: 0 }}>
                                                            {activity.items.map((item, i) => (
                                                                <li key={i} style={{ fontSize: "0.9rem", color: "rgba(255,255,255,0.6)", padding: "5px 0" }}>→ {item}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Why Us Section */}
                        <section style={{ padding: "80px 0", background: "#0a0a0a" }}>
                            <div className="container">
                                <div className="text-center" style={{ marginBottom: "50px" }}>
                                    <span style={{ color: "#fc9038", fontSize: "14px", textTransform: "uppercase", letterSpacing: "2px" }}>Why Us</span>
                                    <h2 style={{ fontSize: "2.5rem", margin: "15px 0 20px", color: "#fff" }}>Why Choose AquarLabs for HR & Payroll?</h2>
                                    <p style={{ fontSize: "1rem", color: "rgba(255,255,255,0.6)", maxWidth: "700px", margin: "0 auto" }}>
                                        We combine HR expertise with cutting-edge technology to deliver solutions that work.
                                    </p>
                                </div>
                                <div className="row">
                                    {[
                                        { title: "99.9% Payroll Accuracy", desc: "AI-powered validation ensures error-free payroll every cycle." },
                                        { title: "Employee Self-Service", desc: "Empower employees with mobile access to payslips and leave requests." },
                                        { title: "Seamless Integrations", desc: "Connect with existing accounting, ERP, and time tracking systems." },
                                        { title: "Data Security", desc: "Enterprise-grade encryption and access controls for sensitive HR data." },
                                        { title: "Scalable Solution", desc: "From 50 to 50,000 employees—our platform grows with you." },
                                        { title: "Dedicated Support", desc: "HR and payroll specialists available to assist your team." }
                                    ].map((item, index) => (
                                        <div key={index} className="col-lg-6" style={{ marginBottom: "20px" }}>
                                            <div style={{
                                                background: "rgba(20, 20, 20, 0.8)",
                                                border: "1px solid rgba(252, 144, 56, 0.4)",
                                                borderRadius: "16px",
                                                padding: "28px 30px",
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "flex-start",
                                                gap: "15px"
                                            }}>
                                                <div style={{
                                                    minWidth: "40px",
                                                    height: "40px",
                                                    borderRadius: "8px",
                                                    background: "rgba(252, 144, 56, 0.1)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}>
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M16 21V19C16 16.7909 14.2091 15 12 15H5C2.79086 15 1 16.7909 1 19V21" stroke="#fc9038" strokeWidth="2" strokeLinecap="round" />
                                                        <circle cx="8.5" cy="7" r="4" stroke="#fc9038" strokeWidth="2" />
                                                        <path d="M17 11L19 13L23 9" stroke="#fc9038" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                                <div>
                                                    <h3 style={{ fontSize: "1.1rem", color: "#fff", marginBottom: "8px", fontWeight: "600" }}>{item.title}</h3>
                                                    <p style={{ fontSize: "0.9rem", color: "rgba(255,255,255,0.6)", margin: 0, lineHeight: "1.6" }}>{item.desc}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </section>

                        {/* CTA Section */}
                        <section style={{ padding: "80px 0", background: "linear-gradient(135deg, rgba(252, 144, 56, 0.1) 0%, rgba(0, 2, 15, 0.5) 100%)" }}>
                            <div className="container text-center">
                                <h2 style={{ fontSize: "2.5rem", color: "#fff", marginBottom: "20px" }}>Transform Your HR Operations</h2>
                                <p style={{ fontSize: "1.2rem", color: "rgba(255,255,255,0.7)", marginBottom: "30px" }}>
                                    Schedule a demo to see how our HR & Payroll solutions can streamline your processes.
                                </p>
                                <Link to="/contact-us" className="thm-btn agency-btn">
                                    <span className="text">Contact Us Today</span>
                                </Link>
                            </div>
                        </section>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default HRPayrollPage;
